// module.exports = {
//     url: 'http://localhost:24313/', /*for development */
//     rootDir: '/dist', //Dev
//     fontDir: '/woooo/fonts',
//     montserrat: '/dist/fonts/montserrat/Montserrat.css',
//     mavenpro: '/dist/fonts/Maven Pro/Maven Pro.css',
//     roboto: 'dist/fonts/Roboto/Roboto.css',
//     studioUrl: 'http://192.168.2.39:6060/'
// }

module.exports = {
    url: '../',
    rootDir: '/designer',
    montserrat: '/static/fonts/montserrat/Montserrat.css',
    mavenpro: '/static/fonts/Maven Pro/Maven Pro.css',
    roboto: '/static/fonts/Roboto/Roboto.css',
    studioUrl: '../'
}
